import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';

import { showModal } from '../../../actions/modal';

import { getCurrencySymbol } from '../../../helpers';

import { PAYMENTS_PAYMENT_METHOD, PAYMENT_PROVIDER_TYPE } from '../../../config';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('tr')`
  .item-remove {
    display: none;
    cursor: pointer;
    padding: 10px 0;
  }

  .item-edit {
    cursor: pointer;
  }

  .edit-icon {
    margin-left: 5px;
    visibility: hidden;
  }

  :hover {
    .item-remove {
      display: block;
    }

    .edit-icon {
      visibility: visible;
    }
  }

  .payment-method-cell {
    img {
      height: 25px;
      margin-left: 20px;
    }
  }
`;

const PaymentRow = (props) => {
  const {
    payment,
    checkoutSettings,
    handleEditPaymentSettings,
    handleDeletePayment,
    paymentProvider,
  } = props;

  const dispatch = useDispatch();

  const { t } = useAutoTranslation();

  const { paymentMethod, checkoutPayment } = payment;
  const discountPercent = checkoutPayment && checkoutPayment.discountType === 'PERCENT';
  const { commercialAccount } = checkoutSettings;

  const paymentMethodObject = PAYMENTS_PAYMENT_METHOD.find(
    (elem) => elem.value === paymentMethod.paymentMethod,
  );
  const currencySymbol = getCurrencySymbol(checkoutSettings.currency);

  const handleDeletePaymentConfirm = () => {
    dispatch(
      showModal('Confirm', {
        body: `${t('Подтвердите удаление способа оплаты')} "${paymentMethod.name}"`,
        handleConfirm: () => handleDeletePayment(payment),
        confirmBtnTitle: t('Удалить'),
      }),
    );
  };

  const discount =
    checkoutPayment && checkoutPayment.isDiscountActive ? (
      <Fragment>
        <div>
          {`${checkoutPayment.discountValue} ${discountPercent ? '%' : currencySymbol}`}
          {checkoutPayment.minApplyValue > 0 ? (
            <span>{` | ${t('заказ от')} ${checkoutPayment.minApplyValue} ${currencySymbol}`}</span>
          ) : null}
        </div>
        <div className="text-muted">
          {discountPercent ? t('Тип: в процентах') : t('Тип: фиксированная')}
        </div>
      </Fragment>
    ) : null;

  const handleEdit = () => (commercialAccount ? handleEditPaymentSettings(payment) : null);

  let paymentLogo;
  if (paymentMethod.paymentMethod === 'ONLINE') {
    const ProviderType = PAYMENT_PROVIDER_TYPE.find(
      (provider) => provider.value === paymentProvider,
    );
    paymentLogo = ProviderType ? ProviderType.logo : null;
  } else {
    paymentLogo = null;
  }

  return (
    <Wrapper className="payment-row">
      <td>
        <div className="item-edit" onClick={handleEdit}>
          <div>
            {t(paymentMethod.name)}
            {commercialAccount ? <i className="fe-edit-2 edit-icon" /> : null}
          </div>
          <div className="text-muted">{paymentMethod.code}</div>
        </div>
      </td>
      <td className="payment-method-cell">
        <span className="text-muted">{paymentMethodObject ? paymentMethodObject.label : ''}</span>
        {paymentLogo ? <img src={paymentLogo} alt="" /> : null}
      </td>
      <td>{discount}</td>
      <td>{checkoutPayment ? t('Покупатели') : t('Только менеджеры')}</td>
      <td style={{ width: '45px' }}>
        {commercialAccount ? (
          <div className="item-remove" onClick={handleDeletePaymentConfirm}>
            <i className="fe-trash-2" />
          </div>
        ) : null}
      </td>
    </Wrapper>
  );
};

export default PaymentRow;
